import { ModuleWithProviders, NgModule, APP_INITIALIZER } from '@angular/core';
import { KwikstoreVisualEditorComponent } from './kwikstore-visual-editor.component';
import { KveRoutingModule } from './kve-routing.module';
import { CommonModule } from '@angular/common';
import { StorethemesModule } from '@urbannex/storethemes';
import { NbAccordionModule, NbActionsModule, NbCardModule, NbIconModule, NbInputModule, NbLayoutModule, NbMenuModule, NbPopoverModule, NbRadioModule, NbSidebarModule, NbTabsetModule, NbThemeModule } from '@nebular/theme';
import { EditorHeaderComponent } from './editor-header/editor-header.component';
import { SideBarMenuesComponent } from './side-bar-menues/side-bar-menues.component';
import { EditorsModule } from './editors/editors.module';
import { PreviewContainerComponent } from './preview-container.component';
import { LayoutEditorService } from './editors/layout-editor/layout-editor.service';
import { PreviewEditStoreService } from './services/preview-edit-store.service';
import { PreviewComponent } from './preview/preview.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HorizontalExpandDirective } from './side-bar-menues/horizontal-expand.directive';
import { PreviewModule } from './preview/preview.module';
import { CssServicesService } from './services/css-services.service';
import { ImageUrlPipe } from './pipes/image-url.pipe';
import { provideAnimations } from '@angular/platform-browser/animations';
import { OfbizFormsModule } from '@urbannex/ofbiz-forms';
import { ConfigurationModule, configurationReducer } from '@urbannex/configuration';
import { HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { AngularTreeGridModule } from "angular-tree-grid";
import { ProjectionTesterComponent } from './projection-tester/projection-tester.component';
import { PREVIEW_URL_TOKEN } from './injection-tokens';
import { StyleContextMenuDirective } from './directives/style-context-menu.directive';


export interface KwikstoreVisualEditorConfig {
  previewUrl: string;
}

/* export const env = {
  production: false,
  apiUrl:'https://localhost:8443/rest',
  defaultLocale:"en-ZA"
};

export function initializeApp2(appInitService: AppInitConfigService) : ()  => Observable<any> {
  return () => appInitService.init(env,"kwikstore-visual-editor-module");
} */
@NgModule({
  declarations: [
    KwikstoreVisualEditorComponent,
    EditorHeaderComponent,
    SideBarMenuesComponent,
    PreviewContainerComponent,
    HorizontalExpandDirective,
    ImageUrlPipe,
    ProjectionTesterComponent
  ],
  imports: [
    CommonModule,
    EditorsModule,
    StorethemesModule,
    NbLayoutModule,
    NbCardModule,
    HttpClientModule,
    NbThemeModule.forRoot({ name: 'navy-kadet' }),
    NbSidebarModule,
    NbAccordionModule,
    NbActionsModule,
    NbMenuModule,
    NbIconModule,
    NbTabsetModule,
    NbInputModule,
    NbRadioModule,
    NbPopoverModule,
    KveRoutingModule,
    PreviewComponent,
    NbAccordionModule,
    FormsModule,
    ReactiveFormsModule,
    PreviewModule,
    OfbizFormsModule.forRoot("https://kwikstore-dev:8443/rest/"),
    ConfigurationModule,
    // StoreModule.forRoot({webSiteConfig:configurationReducer}),
    AngularTreeGridModule
  ],
  providers: [LayoutEditorService,
    PreviewEditStoreService,
    provideAnimations(),
    /* { provide: 'configurationService', useClass: ConfigurationService },
    { provide:APP_INITIALIZER,useFactory:initializeApp2,deps:[AppInitConfigService],multi:true }*/],
  exports: [
    KwikstoreVisualEditorComponent, EditorHeaderComponent, SideBarMenuesComponent, PreviewContainerComponent, ProjectionTesterComponent
  ]
})
export class KwikstoreVisualEditorModule {
  static forRoot(config: KwikstoreVisualEditorConfig): ModuleWithProviders<KwikstoreVisualEditorModule> {
    return {
      ngModule: KwikstoreVisualEditorModule,
      providers: [
        LayoutEditorService,
        PreviewEditStoreService,
        CssServicesService,
        {
          provide: PREVIEW_URL_TOKEN,
          useValue: config.previewUrl
        }]
    };
  }
}

